<template>
  <div>
    <div class="p-4 bg-gradient-to-br from-gray-900 to-black rounded-xl border border-gray-800 shadow-xl">
      <!-- Header با Glass Effect -->
      <div class="mb-6">
        <h3 class="text-xl font-bold inline-block">
          <span class="bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-yellow-400 to-red-400">
            گزارش فروش حضوری
            <span v-if="filters.date"> {{ filters.date.split('-').reverse().join('-') }} </span>
          </span>
        </h3>

        <!-- فیلترها -->
        <div class="mt-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div class="flex flex-wrap gap-3">
            <input v-model="filters.id" @input="fetchOrders(1)" type="number"
                   placeholder="شماره فاکتور"
                   class="px-4 py-2 bg-gray-800/70 text-gray-200 rounded-lg border border-gray-700 w-40 text-right backdrop-blur-sm">

            <date-field
                class="px-4 py-2 bg-gray-800/70 text-gray-200 rounded-lg border border-gray-700 w-40 text-right backdrop-blur-sm"
                placeholder="تاریخ"
                v-model="filters.created_at"
                @input="fetchOrders(1)">
            </date-field>


            <button
                @click="resetFilters"
                class="p-3 bg-gradient-to-r from-gray-700 to-gray-800 text-gray-300 rounded-full border border-gray-600 hover:bg-gray-700 transition"
                title="حذف فیلترها"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- جدول سفارشات فروشگاهی -->
      <div class="overflow-x-auto rounded-xl border border-gray-800">
        <table class="min-w-full table-auto text-right">
          <thead class="bg-gradient-to-r from-gray-800 to-gray-900">
          <tr>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400">ردیف</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">شماره فاکتور</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">تاریخ</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">تعداد اقلام</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">مبلغ اقلام </th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">تخفیف ردیف </th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">مبلغ نهایی </th>
          </tr>
          </thead>
          <tbody class="divide-y divide-gray-800">
          <tr v-for="(order, index) in orders" :key="order.id"
              class="hover:bg-gray-800/50 transition cursor-pointer"
              @click="$router.push(`/panel/partnerInStoreOrderDetail/${order.id}`)">
            <td class="p-3 text-center text-sm text-gray-300">{{ (currentPage - 1) * perPage + index + 1 }}</td>
            <td class="p-3 text-center text-sm text-gray-300">{{ order.id }}</td>
            <td class="p-3 text-center text-xs text-gray-400">{{ order.created_at}}</td>
            <td class="p-3 text-center text-sm text-gray-300">
              {{ order.partner_total_quantity | toMoney }}
              <span class="text-xs text-gray-500 mr-1">عدد</span>
            </td>
            <td class="p-3 text-center text-sm text-gray-300">
              {{ order.partner_total_items_price | toMoney }}
              <span class="text-xs text-gray-500 mr-1">تومان</span>
            </td>
            <td class="p-3 text-center text-sm text-red-400">
              {{ order.partner_total_line_discount | toMoney }}
              <span class="text-xs text-gray-500 mr-1">تومان</span>
            </td>
            <td class="p-3 text-center text-sm text-green-400">
              {{ order.partner_final_amount | toMoney }}
              <span class="text-xs text-gray-500 mr-1">تومان</span>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- حالت خالی -->
        <div v-if="orders.length === 0 && !isLoading" class="py-12 text-center">
          <div class="mx-auto w-16 h-16 bg-gray-800/70 rounded-full flex items-center justify-center mb-4 border border-gray-700">
            <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
            </svg>
          </div>
          <p class="text-gray-400">هیچ فاکتور فروشگاهی یافت نشد</p>
        </div>
      </div>

      <!-- صفحه‌بندی -->
      <div class="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-400 bg-gray-800/70 px-3 py-2 rounded-lg border border-gray-700">
            فاکتور در هر صفحه:
            <input v-model="perPage" @input="fetchOrders(1)" type="text"
                   placeholder="تعداد"
                   class="bg-gray-900 text-gray-300 text-sm rounded border border-gray-700 w-16 mx-1 px-2 py-1 text-center">
          </span>

          <!-- نمایش اطلاعات صفحه -->
          <span class="text-sm text-gray-400 bg-gray-800/70 px-3 py-2 rounded-lg border border-gray-700">
            نمایش {{ orders.length }} از {{ totalCount }} فاکتور
          </span>
        </div>

        <div class="flex gap-2">
          <button @click="prevPage" :disabled="currentPage === 1"
                  class="px-4 py-2 text-sm rounded-lg bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition">
            صفحه قبل
          </button>
          <span class="px-4 py-2 text-sm text-gray-300 bg-gray-800/70 rounded-lg border border-gray-700">
            صفحه {{ currentPage }} از {{ Math.ceil(totalCount / perPage) }}
          </span>
          <button @click="nextPage" :disabled="(currentPage * perPage) >= totalCount"
                  class="px-4 py-2 text-sm rounded-lg bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition">
            صفحه بعد
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="isLoading" class="mt-6 bg-gray-900/50 rounded-xl p-8 text-center border border-gray-800">
        <div class="inline-block">
          <svg class="animate-spin h-10 w-10 text-green-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="mt-3 text-gray-400">در حال بارگذاری...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/mcomponents/cleave/DateField";

export default {
  name: 'PartnerInStoreOrders',
  components: {DateField},
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      totalCount: 0,
      orders: [],
      isLoading: false,
      filters: {
        id: '',
        created_at: '',
        status: '',
      },
    };
  },
  methods: {
    resetFilters() {
      this.filters = {
        id: '',
        created_at: '',
        status: '',
      }
      this.fetchOrders(1)
    },

    nextPage() {
      if ((this.currentPage * this.perPage) < this.totalCount) {
        this.fetchOrders(this.currentPage + 1)
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.fetchOrders(this.currentPage - 1)
      }
    },

    fetchOrders(page = 1) {
      this.isLoading = true
      const offset = (page - 1) * this.perPage

      const params = {
        limit: this.perPage,
        offset: offset,
        ordering: '-id',
      }

      // اضافه کردن فیلترها
      if (this.filters.id) {
        params.id = this.filters.id
      }
      if (this.filters.date) {
        params.date = this.filters.date
      }
      if (this.filters.status) {
        params.status = this.filters.status
      }

      this.request({
        url: this.endpoint('partner-stock/inStoreOrders'),
        params: params,
        method: "get",
        success: data => {
          this.isLoading = false
          this.orders = data.results
          this.totalCount = data.count
          this.currentPage = page
        },
        error: error => {
          this.isLoading = false
          console.error('Error fetching in-store orders:', error)
          this.showNotificationMessage('خطا در دریافت داده‌ها', 'error')
        }
      })
    },

    formatDate(date) {
      if (!date) return "-";
      const dateObj = new Date(date);
      return dateObj.toLocaleDateString('fa-IR');
    },

    getStatusText(status) {
      const statusMap = {
        'dr': 'پیش فاکتور',
        'cf': 'فاکتور خرید',
        'ca': 'فاکتور لغو شده',
        're': 'فاکتور مرجوعی'
      }
      return statusMap[status] || status
    },

    getStatusClass(status) {
      const classMap = {
        'dr': 'bg-yellow-900/30 text-yellow-400 border border-yellow-800/30',
        'cf': 'bg-green-900/30 text-green-400 border border-green-800/30',
        'ca': 'bg-red-900/30 text-red-400 border border-red-800/30',
        're': 'bg-orange-900/30 text-orange-400 border border-orange-800/30'
      }
      return classMap[status] || 'bg-gray-800 text-gray-300'
    },

    showNotificationMessage(message, type = 'success') {
      // پیاده‌سازی نمایش نوتیفیکیشن
      this.$notify({
        type: type === 'error' ? 'error' : 'success',
        title: type === 'error' ? 'خطا' : 'موفق',
        text: message,
        duration: 3000
      });
    },
  },

  mounted() {
    this.fetchOrders(1);
  },

  // فیلتر toMoney
  filters: {
    toMoney(value) {
      if (value === undefined || value === null) return '0';
      const num = Number(value);
      if (isNaN(num)) return '0';
      return new Intl.NumberFormat('fa-IR').format(Math.round(num));
    }
  }
};
</script>

<style scoped>
/* تنظیمات Glass Effect */
.glass-effect {
  background: rgba(30, 41, 59, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* تنظیمات RTL */
[dir="rtl"] .space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

/* اسکرول بار زیبا */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

/* انیمیشن‌های ظریف */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* انیمیشن اسپینر */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* استایل مخصوص hover روی سطرها */
tr {
  transition: all 0.2s ease;
}

tr:hover {
  transform: translateX(-2px);
  box-shadow: inset 2px 0 0 rgba(34, 197, 94, 0.5);
}
</style>